import { c as _c } from "react/compiler-runtime";
import { SkeletonLine } from "@opensea/ui-kit";
export function ItemsCountSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SkeletonLine className="h-4 w-16" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}